import { Box, styled, Typography } from '@mui/material';

export const UniqueSpaceText = styled(Typography)`
  font-size: 2rem;
  line-height: 1.813rem;
  letter-spacing: 0.436364px;
`;
